/** GNB > contentType Map */
export const gnbContentTypeMap = {
  '/main': 'G_home',
  '/calendar': 'G_calendar',
  '/selection': 'gnb_calendar',
  '/fortune': 'G_daily_fortune',
  '/saju-input': 'G_manse',
  '/saju-service': 'G_member',
  '/nangman-center/notice': 'G_nangman_center',
  '/guide/info': 'gnb_btn_service',
  // 서비스구매 전용 (link '/purchase/tickets'는 basePath '/purchase'로 폴백 매칭). 신규 type — DB 등록 후 작동
  '/purchase': 'gnb_btn_service_purchase',
};

/** 낭만센터 NangmanCenter > ContentType Map */
export const nangmanCenterContentTypeMap = {
  '/nangman-center/notice': 'N_tab_notice',
  '/nangman-center/event': 'N_tab_event',
  '/nangman-center/essay': 'N_tab_essay',
  '/nangman-center/faq': 'N_tab_faq',
  '/nangman-center/word': 'N_tab_guide',
  // '/nangman-center/inquiry': 'N_tab_inquiry',
  // '/nangman-center/counseling': 'N_tab_counseling',
};

/** 사용자메뉴 UserMenu > ContentType Map */
export const userMenuContentTypeMap = {
  '/mypage/myinfo': 'UM_myinfo',
  '/mypage/moreinfo': 'UM_moreinfo',
  '/mypage/inquiry': 'UM_inquiry',
  '/mypage/inquiryList': 'UM_inquiry_list',
};
